export const bibliographyNode = {
  group: 'block',
  content: 'inline*',
  attrs: {
    entries: { default: [] },
    styleLabel: { default: '' },
  },
  parseDOM: [{ tag: 'div.bibliography-node' }],
  toDOM() { return ['div', { class: 'bibliography-node' }, 0]; },
};
export default bibliographyNode;
